import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const ConditionReport = ({ conditionReport }: SpecProps<"condition_report">) => {
  const { i18n } = useLingui();

  if (conditionReport === undefined) {
    return null;
  }

  const hasConditionReport =
    typeof conditionReport === "boolean"
      ? conditionReport
      : !!conditionReport.car_condition_doc_available || !!conditionReport.link;

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.conditionReport.title",
    message: "Condition report",
    comment: "Field for 'condition' in ad specification",
  });

  return <FieldValuePair field={field} value={hasConditionReport} />;
};
